module.exports = __webpack_public_path__ + "static/media/Platinum-Host-Reseller.25ddeb9b.png";